<template>
  <div class="page-bg">
    <!-- Header -->
    <Header
      headerTitle="车辆认证"
      :hasBackBtn="true"
      rightIconSrc="https://zimg.chinasinoair.com/52fb7eb51a9db623e4eb1bf040139148?f=png"
      iconShow
      :onRightBtnClick="vehicleLicenseServiceCall"
    ></Header>
    <div>
      <div class="image-container">
        <van-uploader
          style="width: 100%"
          v-model="fileList"
          :disabled="
            vehicleLicense.authStatus && vehicleLicense.authStatus !== 1
          "
          :deletable="!vehicleLicense.authStatus"
          accept="image/*"
          preview-size="100%"
          :max-count="1"
          @delete="deleteVehicleLicense"
          :after-read="afterRead"
          :before-read="beforeRead"
          upload-text="点击上传行驶证，自动填写信息"
          upload-icon="https://zimg.chinasinoair.com/e6d9d6a329466b3636f444a064fafe0b?f=png"
        />
      </div>

      <div class="cell-row" style="margin-top:20px">
        <van-cell
          title="号牌号码"
          :value="
            `${vehicleLicense.plate_no ? vehicleLicense.plate_no : '未识别'}`
          "
          size="large"
        />
        <van-cell
          title="车辆类型"
          :value="
            `${
              vehicleLicense.vehicle_type
                ? vehicleLicense.vehicle_type
                : '未识别'
            }`
          "
          size="large"
        />
        <van-cell title="品牌型号" size="large">
          <template #default>
            <span
              :style="{
                color: vehicleLicense && !vehicleLicense.isBMW ? 'red' : '',
              }"
              >{{
                vehicleLicense.model ? vehicleLicense.model : "未识别"
              }}</span
            >
          </template>
        </van-cell>
        <van-cell
          title="所有人"
          :value="`${vehicleLicense.owner ? vehicleLicense.owner : '未识别'}`"
          size="large"
        />
      </div>
    </div>
    <footer>
      <div class="footer-container">
        <b-button
          class="ve-btn"
          :disabled="
            vehicleLicense.authStatus === 2 || !vehicleLicense.photoUrl
          "
          @click="submitManualAuth(2)"
          >{{ btnTitle }}</b-button
        >
        <div
          v-if="
            !vehicleLicense.isBMW &&
              (vehicleLicense.authStatus
                ? vehicleLicense.authStatus === 1
                : true)
          "
          class="footer-tip"
          @click="handleNeedManualAuth"
        >
          识别不正确，需要人工审核？
        </div>
      </div>
    </footer>

    <b-modal
      ref="notice-vehicle-license"
      id="notice-vehicle-license"
      ok-only
      no-close-on-backdrop
      class="notice"
      static
      ok-title="我知道了"
    >
      <h5 style="margin-top: 12px">
        <b
          ><strong>{{ noticeTitle }}</strong></b
        >
      </h5>
      <p
        class="my-sm-6"
        style="margin-bottom:5px !important;padding:0 25px;font-size:12px;"
      >
        {{ noticeInfo }}
      </p>
    </b-modal>

    <b-modal
      ref="notice-vehicle-license-manual"
      id="notice-vehicle-license-manual"
      no-close-on-backdrop
      class="notice"
      static
      ok-title="提交人工"
      cancel-title="取消"
      @ok="submitManualAuth(1)"
    >
      <h5 style="margin-top: 12px">
        <b
          ><strong>{{ noticeTitle }}</strong></b
        >
      </h5>
      <p
        class="my-sm-6"
        style="margin-bottom:5px !important;padding:0 25px;font-size:12px;"
      >
        {{ noticeInfo }}
      </p>
    </b-modal>

    <b-modal
      ref="notice-vehicle-license-unbind"
      id="notice-vehicle-license-unbind"
      no-close-on-backdrop
      class="notice"
      static
      ok-title="确定"
      cancel-title="取消"
      @ok="handleUnbindVehicleLicense()"
    >
      <h5 style="margin-top: 12px">
        <b><strong>确定解绑绑定车辆？</strong></b>
      </h5>
    </b-modal>

    <!-- 提示信息 -->
    <Tip :message="message" :type="tipType" :show="tipShow"></Tip>
  </div>
</template>

<script>
import {
  userInfo,
  authUserVehicleLicense,
  queryVehicleLicenseAuth,
  unbindVehicleLicense,
} from "../../api/user.js";
import { logout } from "../../api/login.js";
import { ocrVehicleLicense } from "../../api/public.js";
import axios from "axios";
import config from "@/config/Config.vue";
import Compressor from "compressorjs";

export default {
  name: "userCenter",
  data() {
    return {
      resultList: {}, //数据
      message: "", //提示信息
      tipShow: "0", //是否提示
      tipType: "", //提示类型
      btnTitle: "绑定车辆",
      vehicleLicense: {
        isBMW: true,
      },
      noticeTitle: "",
      noticeInfo: "",
      fileList: [],
    };
  },
  created() {
    this.loadUserInfo();
    this.handleQueryVehicleLicenseAuth();
  },
  methods: {
    handleQueryVehicleLicenseAuth() {
      queryVehicleLicenseAuth().then((res) => {
        this.vehicleLicense = res.data.result;
        if (res.data.result == null) {
          this.vehicleLicense = {};
          this.vehicleLicense.isBMW = true;
        } else {
          if (!this.vehicleLicense.model) {
            this.vehicleLicense.isBMW = true;
          }
          if ("宝马".indexOf(this.vehicleLicense.model) > -1) {
            this.vehicleLicense.isBMW = true;
          }
          if (this.vehicleLicense.photoUrl) {
            this.fileList = [];
            this.fileList.push({
              url: this.vehicleLicense.photoUrl,
              isImage: true,
            });
          }
        }

        if (this.vehicleLicense.authStatus === 2) {
          this.btnTitle = "审核中";
        }
        if (this.vehicleLicense.authStatus === 3) {
          this.btnTitle = "解绑车辆";
        }
      });
    },
    beforeRead(file) {
      return new Promise((resolve) => {
        // compressorjs 默认开启 checkOrientation 选项
        // 会将图片修正为正确方向
        new Compressor(file, {
          quality: 0.6,
          success: resolve,
          error(err) {
            console.log(err.message);
          },
        });
      });
    },
    afterRead(file) {
      let formData = new FormData();
      formData.append("file", file.file);
      axios({
        url: config.WEB_OCR_VEHICLE_LICENSE_API,
        data: formData,
        method: "post",
        header: {
          "Content-Type": "multipart/form-data",
        },
      }).then((result) => {
        this.vehicleLicense = result.data.result;
        if (this.vehicleLicense && this.vehicleLicense.model) {
          this.vehicleLicense.isBMW = this.vehicleLicense.model.startsWith(
            "宝马"
          );
        }
      });
    },
    handleUnbindVehicleLicense() {
      this.vehicleLicense.licensePlate = this.vehicleLicense.plate_no;
      unbindVehicleLicense(this.vehicleLicense).then((res) => {
        this.tipShow = "1" + Math.random() * 1000;
        this.message = "解绑成功";
        this.tipType = "success";
        this.vehicleLicense = {};
        this.vehicleLicense.isBMW = true;
        this.fileList = [];
        this.handleQueryVehicleLicenseAuth();
        this.btnTitle = "绑定车辆";
      });
    },
    // 行驶证认证服务电话
    vehicleLicenseServiceCall() {
      window.location.href = "tel://4001150606";
    },
    deleteVehicleLicense() {
      this.vehicleLicense = {};
      this.vehicleLicense.isBMW = true;
    },
    handleNeedManualAuth() {
      this.noticeTitle = "识别有问题？需要人工审核？";
      this.noticeInfo = "人工审核需要先上传清晰的行驶证照片";
      this.$refs["notice-vehicle-license-manual"].show();
    },
    submitManualAuth(manualAuth) {
      // 解绑车辆
      // if (
      //   this.vehicleLicense.authStatus != 1 &&
      //   this.vehicleLicense.authStatus != 2 &&
      //   this.vehicleLicense.authStatus != 3
      // ) {
      //   this.$refs["notice-vehicle-license-unbind"].show();
      //   return;
      // }
      if (this.vehicleLicense.authStatus === 3) {
        this.$refs["notice-vehicle-license-unbind"].show();
        return;
      }

      if (manualAuth === 2 && !this.vehicleLicense.isBMW) {
        this.noticeTitle = "绑定车辆非宝马品牌车型！";
        this.noticeInfo = "本权益仅限宝马品牌车主参与";
        // this.$refs["notice-vehicle-license"].show();
        this.$refs["notice-vehicle-license"].show();

        return;
      }
      this.vehicleLicense.manualAuth = manualAuth;
      authUserVehicleLicense(this.vehicleLicense).then((res) => {
        this.tipShow = "1" + Math.random() * 1000;
        this.message = "提交成功";
        this.tipType = "success";
        this.handleQueryVehicleLicenseAuth();
      });
    },
    uploadVehicleLicense(e) {
      if (e.target.files.length === 0) {
        return;
      }
      let formData = new FormData();
      formData.append("file", e.target.files[0]);
      axios({
        url: config.WEB_OCR_VEHICLE_LICENSE_API,
        data: formData,
        method: "post",
        header: {
          "Content-Type": "multipart/form-data",
        },
      }).then((result) => {
        this.vehicleLicense = result.data.result;
        if (this.vehicleLicense.model.startsWith("宝马") || this.vehicleLicense.model.startsWith("MINI") || this.vehicleLicense.model.startsWith("劳斯莱斯")) {
          this.vehicleLicense.isBMW = true
        }
      });
    },
    //退出登录
    onLogin: function() {
      logout().then((response) => {
        if (response.data.status === 200) {
          localStorage.removeItem("token");
          this.$router.push("/Login");
        } else {
          this.tipShow = "1" + Math.random() * 1000;
          this.message = "退出失败 , 请重试";
          this.tipType = "warning";
        }
      });
    },
    //获取数据
    loadUserInfo: function() {
      userInfo().then(
        (response) => {
          if (response.data.status == 200) {
            this.resultList = response.data.result;
          } else {
            this.tipShow = "1" + Math.random() * 1000;
            this.message = response.data.message;
            this.tipType = "warning";
          }
        },
        (err) => {
          reject(err);
        }
      );
    },
  },
};
</script>

<style scoped>
a {
  color: #2c3e50;
}

a:link {
  text-decoration: none;
  color: #2c3e50;
}

a:visited {
  text-decoration: none;
  color: #2c3e50;
}

span {
  text-align: right;
  font-family: HiraginoSansGB-W6;
}

.container {
  padding-top: 10px;
}

.avatar {
  position: relative;
  top: 3px;
}

.phone {
  text-align: right;
  padding-right: 0px;
}

.phone .col {
  padding-right: 10px;
}

.phone span.number {
  font-size: 25px !important;
}

.phone span.license {
  width: 40%;
  display: inline-block;
  text-align: center;
  background-color: #ccc;
  line-height: 30px;
}

.bind-vip {
  height: 63px;
  line-height: 63px;
  border: 1px solid #e6e6e6;
  text-align: left;
  margin: 20px 0px;
  margin-top: 30px;
  margin-bottom: 5px;
  border-radius: 5px;
  font-size: 13px;
}

.list-group .item {
  padding-top: 20px;
  padding-bottom: 20px;
  text-align: left;
}

.list-group .item span {
  margin-left: 10px;
  font-size: 15px;
}
.list-group .item img {
  margin-top: 3px;
}
.triangle_border_right {
  width: 0;
  height: 0;
  border-width: 6px 0 6px 6px;
  border-style: solid;
  border-color: transparent transparent transparent #d1d1d1;
  /*透明 透明 透明 灰*/
  position: relative;
  float: right;
  top: 6px;
}

.info-triangle-btn {
  margin: 0px;
  padding: 0px;
}

.info-triangle-btn img {
  height: 25px;
  margin-top: 17px;
}

.info-triangle-btn .triangle_border_right {
  top: 24px;
  float: left;
  margin-left: 18px;
}

.bind-vip .triangle_border_right {
  top: 24px;
}
footer {
  margin-top: 100px;
  color: #0066b1;
  /* height: 90px; */
  margin: 0 10px;
  position: fixed;
  bottom: 30px;
  left: 0;
  width: 93%;
}
</style>
<style>
.introduce .modal-content {
  margin: 0 auto;
  margin-top: 100px;
  width: 95%;
}
.introduce .modal-header {
  padding: 0rem;
}
footer .loginout-body {
  display: none !important;
  margin: 0px;
}
footer .modal-content .modal-footer .btn-secondary:last-child {
  margin-right: 0px;
  color: #fff;
  background-color: #0066b1;
}
footer .modal-content {
  width: 80%;
  margin-left: 10%;
}
.image-container {
  width: 100%;
  height: 280px;
  background: #f7f9fd;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0px 2px 0px 10px;
}
.vehicle-license-container {
  width: 100%;
  padding: 30px;
  height: 280px;
  border-radius: 8px;
}

.vehicle-license-container img {
  height: 280px;
  width: 100%;
}
.image-container .image-tip {
  margin-top: 16px;
  height: 16px;
  font-size: 14px;
  font-weight: 400;
  color: #0061b1;
  line-height: 14px;
}
.context-container {
  margin-top: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.context-container .context-row {
  width: 100%;
  height: 48px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
.footer-container {
  width: 97%;
  margin: 0 auto;
}
.ve-btn {
  width: 80% !important;
  height: 40px;
  color: #ffffff !important;
  background: #0061b1 !important;
  border-radius: 12px;
  border: 1px solid #0061b1;
  position: absolute;
  bottom: 0;
  left: 0;
  margin-bottom: 20px;
  margin-left: 42px;

}
.footer-tip {
  margin-top: 8px;
  width: 100%;
  height: 14px;
  font-size: 14px;
  font-weight: 400;
  color: #0061b1;
  line-height: 14px;
  text-align: left;
  margin-left: 15px;
}
#vehicleLicense {
  width: 100%;
  height: 100%;
  opacity: 0;
}
input[type="file"] {
  top: -100px !important;
  height: 280px !important;
}
</style>
